import React from 'react';
import * as S from './d404.styles';
import ErrorPage404Icon from './d404.icon';

const ErrorPage404 = () => (
  <S.BodySection>
    <S.ErrorPageOuterWrapDiv>
      <S.ErrorPageLeftWrapper>
        <S.ErrorCode>404</S.ErrorCode>
        <S.ErrorCodeDescrption>You've landed in No Man's Land! </S.ErrorCodeDescrption>
        <S.ErrorCodeSubDescription>
          We're sorry. The page that you are looking for does not exist
        </S.ErrorCodeSubDescription>
        <S.NavigationList>
          Go Back to
          <li>
            <S.ListItem href="/flights">Flights</S.ListItem>
          </li>
          <li>
            <S.ListItem href="/bus">Buses</S.ListItem>
          </li>
          <li>
            <S.ListItem href="/hotels">Hotels</S.ListItem>
          </li>
          <li>
            <S.ListItem href="/trains">Trains</S.ListItem>
          </li>
        </S.NavigationList>
      </S.ErrorPageLeftWrapper>
      <ErrorPage404Icon />
    </S.ErrorPageOuterWrapDiv>
  </S.BodySection>
);

export default ErrorPage404;
